import { Ease } from "../Ease";
import ClipboardUtils from "./ClipboardUtils";

interface INumericControl {
    label: HTMLLabelElement;
    range: HTMLInputElement;
    span: HTMLSpanElement;
}

class ReelConfigurator 
{
    private defaultEase = Ease.BackOut;

    public init(app: any, reelgroup: any, urlParam: string, maxExtraSymsAllowed: number, isMobile: boolean) {
        const container = document.createElement("div");
        container.id = "wienerReelConfigurator";
        container.style.cssText = 
        `
        width: 390px;
        height: 580px;
        position: absolute;
        top: ${isMobile ? '50px' : '0px'};
        left: 0px;
        min-height: 580px;
        min-width: 200px;
        max-width: 390px;
        background-color: rgba(40,59,59, 0.98);
        overflow: auto;
        color: #000;
        resize: both;
        padding: 5px;
        border-radius: 8px;
        `;

        let header = document.createElement("div");
        header.style.height = "80px";

        let logo = document.createElement("h2");
        logo.innerText = "Wiene® Reel Configurator";
        logo.style.cssText = "vertical-align: middle; text-align: center; height: 25px; color: black; position: relative; top: 30px; display: block;     filter: drop-shadow(0.1rem 0.3rem 0.1rem rgb(0, 102, 102));";

        let importButton = document.createElement("input");
        importButton.type = "button";
        importButton.value = "Import";
        importButton.style.cssText = 
        `
        width: 70px;
        height: 30px;
        diplay: block;
        position: absolute;
        top: 0px;
        right: 80px;
        margin: 5px;
        opacity: 0.8;
        border-radius: 8px;
        `;

        const configurator = this;
        importButton.onclick = function() {
            let input = prompt("Enter reel configuration");
            if (!input) {
                return;
            }

            let startIdx = input.indexOf("{");
            let endIdx = input.indexOf("}");
            if (startIdx == -1 || endIdx == -1) {
                alert("Invalid reel configuration!");
                return;
            }

            try {
                let data = input.substring(startIdx, endIdx + 1);
                let obj = JSON.parse(data);
                let keys = Object.keys(obj);
                if (keys.length == 0) {
                    alert("Empty reel configuration!");
                    return;
                }

                configurator.importConfig(obj, app);
            } catch (error) {
                alert("Import failed!\n" + error);
            }
        };

        let exportButton = document.createElement("input");
        exportButton.type = "button";
        exportButton.value = "Export";
        exportButton.style.cssText = 
        `
        width: 70px;
        height: 30px;
        diplay: block;
        position: absolute;
        top: 0px;
        right: 0px;
        margin: 5px;
        opacity: 0.8;
        border-radius: 8px;
        `;

        exportButton.onclick = function() {
            ClipboardUtils.copyToClipboard(JSON.stringify(configurator.generateConfig(app), null, 4));
            alert("Reel configuration copied to clipboard!");
        };
        
        header.appendChild(logo);
        header.appendChild(importButton);
        header.appendChild(exportButton);

        const easeControl = this.createEaseSelector(app);
        const extraSymsControl = this.createNumericControl(
            "rc_reelExtraSymbols",
            1,
            maxExtraSymsAllowed,
            app.config.reelExtraSymbols,
            1,
            "Extra syms count*",
            "",
            (e: INumericControl) => {
                const value = parseInt(e.range.value);
                e.span.innerHTML = value.toString();
    
                if (confirm(`Reload page and set new extra symbols count to ${value}?\n\nWe will copy the current configuration to the clipboard, so if you proceed, please import it right after the page reloads, otherwise you might loose your changes.`)) {
                    const updateConfigAndSaveToClipboard = () => {
                        app.config.reelExtraSymbols = value;
                        const config = this.generateConfig(app);
                        ClipboardUtils.copyToClipboard(JSON.stringify(config, null, 4));
                    };

                    const url = window.location.href;
                    const newParam = `${urlParam}=${value}`;
        
                    // We need to reload the page in order to recreate the reel group.
                    if (url.includes(urlParam)) {
                        const search = urlParam + "=" + app.config.reelExtraSymbols;
                        const result = url.replace(search, newParam);
                        updateConfigAndSaveToClipboard();
                        window.location.href = result;
                    } else {
                        updateConfigAndSaveToClipboard();
                        window.location.href += "&" + newParam;
                    }

                    return true;
                } else {
                    e.range.value = app.config.reelExtraSymbols;
                    e.span.innerHTML = app.config.reelExtraSymbols;
                    return false;
                }
            });

        const speedControl = this.createNumericControl("rc_maxReelSpeed", 3000, 10000, parseInt(app.config.maxReelSpeed), 100, "Max Reel Speed", "", (e: INumericControl) => {
                const value = parseInt(e.range.value);
                app.config.maxReelSpeed = value;
                reelgroup.spinners.forEach(spinner => {
                    (<any>spinner).maxSpeed = value;
                })

                return true;
            }
        );

        const minSpinTimeControl = this.createNumericControl("rc_minSpinTime", 0, 5, parseFloat(app.config.minSpinTime), 0.1, "Min Spin Time", "sec", (e: INumericControl) => {
            app.config.minSpinTime = parseFloat(e.range.value);
            return true;
        });

        const quickSpinTimeControl = this.createNumericControl("rc_quickSpinTime", 0, 3, parseFloat(app.config.quickSpinTime), 0.1, "Quick Spin Time", "sec", (e: INumericControl) => {
            app.config.quickSpinTime = parseFloat(e.range.value);
            return true;
        });

        const maxStopTimeControl = this.createNumericControl("rc_maxStopTime", 0, 10, parseFloat(app.config.maxStopTime), 0.1, "Max Stop Time", "sec", (e: INumericControl) => {
            app.config.maxStopTime = parseFloat(e.range.value);
            return true;
        });

        const stopTimeControl = this.createNumericControl("rc_stopTime", 0, 10, parseFloat(app.config.stopTime), 0.1, "Stop Time", "sec", (e: INumericControl) => {
            app.config.stopTime = parseFloat(e.range.value);
            return true;
        });

        const stopDelayTimeControl = this.createNumericControl("rc_reelStopDelayTime", 0, 1, parseFloat(app.config.reelStopDelayTime), 0.005, "Stop Delay Time", "sec", (e: INumericControl) => {
            app.config.reelStopDelayTime = parseFloat(e.range.value);
            return true;
        });

        const instantStopDelayTimeControl = this.createNumericControl("rc_instantStopDelayTime", 0, 1, parseFloat(app.config.instantStopDelayTime), 0.005, "Instant Stop Delay Time", "sec", (e: INumericControl) => {
            app.config.instantStopDelayTime = parseFloat(e.range.value);
            return true;
        });

        const quickStopDelayTimeControl = this.createNumericControl("rc_quickStopDelayTime", 0, 1, parseFloat(app.config.quickStopDelayTime), 0.1, "Quick Stop Delay Time", "sec", (e: INumericControl) => {
            app.config.quickStopDelayTime = parseFloat(e.range.value);
            return true;
        });

        const spinificationDurationControl = this.createNumericControl("rc_reelSpinificationDuration", 0, 5, parseFloat(app.config.reelSpinificationDuration), 0.1, "Anticipation Duration", "sec", (e: INumericControl) => {
            app.config.reelSpinificationDuration = parseFloat(e.range.value);
            return true;
        });

        const controls = [
            header,
            easeControl,
            extraSymsControl,
            speedControl,
            minSpinTimeControl,
            quickSpinTimeControl,
            stopTimeControl,
            maxStopTimeControl,
            stopDelayTimeControl,
            instantStopDelayTimeControl,
            quickStopDelayTimeControl,
            spinificationDurationControl
        ];

        controls.forEach(control => {
            container.appendChild(control);
            container.appendChild(document.createElement("p"));
        })

        container.onkeypress = function(e) {
            if (e.keyCode ===  32) { 
                e.preventDefault(); 
                return false;
            } 
        }

        document.body.appendChild(container);

        if (!app.config.reelSpinEase) {
            app.config.reelSpinEase = this.defaultEase;
        }
    }

    private props = [
        "reelSpinEase",
        "reelExtraSymbols",
        "maxReelSpeed",
        "minSpinTime",
        "quickSpinTime",
        "stopTime",
        "maxStopTime",
        "reelStopDelayTime",
        "instantStopDelayTime",
        "quickStopDelayTime",
        "reelSpinificationDuration"
    ];

    private importConfig(obj: any, app) {
        const idToSkip = "reelExtraSymbols";
        let extraSkipped = false;
        let extraPresent = false;
        let importedCount = 0;
        let changedCount = 0;
        Object.keys(obj).forEach(key => {
            if (this.props.includes(key)) {
                if (key == idToSkip) {
                    extraPresent = true;
                    if (app.config[key] != obj[key]) {
                        extraSkipped = true;
                    }
                } else {
                    app.config[key] = obj[key];
                    const element = document.getElementById(`rc_${key}`) as any;
                    if (element.value != obj[key]) {
                        changedCount++;
                    }

                    element.value = obj[key];
                    element.onchange(null);

                    importedCount++;
                }
            }
        })

        if (importedCount == 0) {
            alert("No valid properties to import");
            return;
        }

        if (extraSkipped) {
            alert(`Extra Syms count was skipped.\nImport value: ${obj[idToSkip]}\nCurrent value: ${app.config[idToSkip]}`);
            return;
        } else {
            if (this.props.length != importedCount) {
                if (extraPresent && this.props.length - 1 != importedCount) {
                    alert(`Partial config loaded: ${importedCount}/${this.props.length - 1} properties.`);
                    return;
                }
            }
        }

        if (changedCount == 0) {
            alert("You are already using the same configuration.");
        }
    }

    private generateConfig(app): object {
        let obj = {};
        this.props.forEach(p => {
            obj[p] = app.config[p];
        });

        return obj;
    }

    private createEaseSelector(app): HTMLDivElement {
        const easeSelectorLabel = document.createElement("label");
        easeSelectorLabel.htmlFor = "rc_reelSpinEase"
        easeSelectorLabel.innerHTML = "Reel Spin Ease: ";

        const easeSelector = document.createElement("select");
        easeSelector.id = "rc_reelSpinEase";
        easeSelector.style.cssText = "width: 180px";

        // Older iOS does not support Object.values();
        let enumValues: string[] = [];
        for (const key in Ease) {
            enumValues.push(Ease[key].toString());
        }

        const options: HTMLOptionElement[] = [];
        for (var i = 0; i < enumValues.length; i++) {
            if (enumValues[i].includes("{") || enumValues[i].includes("true") || enumValues[i].includes("false")) {
                continue;
            }

            var option = document.createElement("option");
            option.value = enumValues[i];
            option.text = enumValues[i];
            options.push(option);
            easeSelector.appendChild(option);
        }

        easeSelector.value = app.config.reelSpinEase || this.defaultEase;
        easeSelector.onchange = function() {
            app.config.reelSpinEase = easeSelector.value;
        };

        const checkbox = document.createElement("input");
        checkbox.type = "checkbox";
        checkbox.id = "reelEaseFilterCheckbox";
        checkbox.style.cssText = "margin-left: 15px; vertical-align: middle";

        checkbox.onchange = function() {
            options.forEach(option => {
                option.style.display = "";
                if (checkbox.checked && !option.innerHTML.includes("out")) {
                    option.style.display = "none";
                }
            })
        };

        const label = document.createElement("label");
        label.htmlFor = checkbox.id;
        label.innerHTML = "Out only";
        label.style.cssText = "vertical-align: middle; user-select: none";

        const div = document.createElement("div");
        div.style.cssText = "text-align: center";

        div.appendChild(easeSelectorLabel);
        div.appendChild(easeSelector);
        div.appendChild(checkbox);
        div.appendChild(label);

        return div;
    }

    private createNumericControl(id: string, min: number, max: number, value: number, step: number, text: string, spanSuffix: string, onchange: (arg: INumericControl) => boolean): HTMLDivElement {
        const label = document.createElement("label");
        label.htmlFor = id;
        label.innerHTML = " " + text;

        const range = document.createElement("input");
        range.id = label.htmlFor;
        range.type = "range";
        range.min = min.toString();
        range.max = max.toString();
        range.step = step.toString();
        range.value = value.toString();
        range.style.cssText = "vertical-align: middle;";

        const span = document.createElement("span");
        span.style.cssText = "min-width: 80px; display: inline-block; margin-left: 5px; vertical-align: middle;";
        span.innerHTML = range.value + " " + spanSuffix;
        
        range.onchange = function() {
            if (onchange({label: label, range: range, span: span})) {
                span.innerHTML = range.value + " " + spanSuffix;
            }
        };

        const div = document.createElement("div");
        div.appendChild(range);
        div.appendChild(span);
        div.appendChild(label);

        return div;
    }
}

export default new ReelConfigurator();